<template>
  <div class="non-optimal-wrapper">
    <WithTips icon="bi-exclamation" iconColor="#F48400" :buttonBack="true" :buttonRestart="true" :buttonNext="true">
      <template #title>
        <span v-safe-html="$t('game.preGameModalChecksNonOptimal.title')"></span>
      </template>
      <template #text>
        <span v-safe-html="$t('game.preGameModalChecksNonOptimal.text')"></span>
      </template>
      <template #subtext>
        <span v-safe-html="$t('game.preGameModalChecksNonOptimal.subtext')"></span>
      </template>
      <template #tipsTop>
        <span v-safe-html="$t('game.preGameModalChecksNonOptimal.tipsTop')"></span>
      </template>
      <template #tipsList>
        <li v-safe-html="$t('game.preGameModalChecksNonOptimal.tip1')"></li>
        <li v-safe-html="$t('game.preGameModalChecksNonOptimal.tip2')"></li>
        <li v-safe-html="$t('game.preGameModalChecksNonOptimal.tip3')"></li>
        <li v-safe-html="$t('game.preGameModalChecksNonOptimal.tip4')"></li>
        <li v-safe-html="$t('game.preGameModalChecksNonOptimal.tip5')"></li>
      </template>
      <template #tipsBottom>
        <span v-safe-html="$t('game.preGameModalChecksNonOptimal.tipsBottom')"></span>
      </template>
    </WithTips>
  </div>
</template>

<script setup lang="ts">
import WithTips from "./WithTips.vue"
</script>
